export const environment = {
  production: true,
  deploymentType:"",
  api_url: 'https://fewapos-brac.imark.com.np',
  web_client_url: 'https://fewapos-brac.imark.com.np',
  
  secretKey: 'YouKnowItIsNotASecretAnyMore'
};
